import { writeCookie } from "common/utils/cookie";
import "./ie11-warning.scss";

export default () => {
  const wrapper = document.querySelector(".js-ie11-warning");
  const closeButton = document.querySelector(".js-ie11-warning-close");

  closeButton.addEventListener("click", () => {
    wrapper.classList.add("hidden");
    writeCookie("ie11-warning-hidden", "true");
  });
};
